import './styles.scss'
import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'
import ClickOutHandler from 'react-onclickout'

import { InputControls } from 'components/common'
import { getStaticImage } from 'utils/statics'

const CheckboxSelector = ({ classNameContainer, selectorOptions = [], onChange, tooltip, isDisabled }) => {
  const [isOpenOptions, setIsOpenOptions] = useState(false)
  const selectedOptions = selectorOptions.filter(option => option.value)

  const toggleOptions = () => setIsOpenOptions(!isOpenOptions)

  return (
    <div
      title={tooltip || ''}
      className={`checkbox-selector ${classNameContainer || ''}`}
    >
      <button
        className={`
          checkbox-selector__selector-btn
          ${isDisabled ? 'checkbox-selector__selector-btn--disabled' : ''}
        `}
        onClick={!isDisabled ? toggleOptions : () => null}
      >
        <strong>
          {selectedOptions.length === 1
            ? selectedOptions[0].name
            : selectedOptions.length > 1
              ? <span>{selectedOptions.length} {I18n.t('dashboard_selected-plural')}</span>
              : I18n.t('dashboard_folders')
          }
        </strong>
        <figure>
          <img src={getStaticImage('/icons/orange-brand/icon-arrow-down-gray.svg')} alt='Down arrow' />
        </figure>
      </button>
      {isOpenOptions ? (
        <ClickOutHandler onClickOut={toggleOptions}>
          <ul className='checkbox-selector__selector-options'>
            {selectorOptions.length ? (
              selectorOptions.map((selectorOption, index) => (
                <li key={index} className='checkbox-selector__selector-option'>
                  <i
                    className='fa fa-folder-o'
                    aria-hidden='true'
                    style={{
                      color: selectorOption.color || '#333333'
                    }}
                  ></i>
                  <p className='text-ellipsis'>{selectorOption.name}</p>
                  <InputControls
                    className='checkbox-selector__checkbox'
                    injectType='external'
                    type='checkbox'
                    value={selectorOption.value}
                    onChange={value => onChange({ id: selectorOption.id || selectorOption.name, value })}
                  />
                </li>
              ))
            ) : (
              <p className='checkbox-selector__no-options-text'>{I18n.t('dashboard_no-options')}</p>
            )}
          </ul>
        </ClickOutHandler>
      ) : null}
    </div>
  )
}

export default CheckboxSelector
